import store from '../store';
import { refreshAccessToken } from '../slices/authSlice';

const authFetch = async (url, options = {}) => {
    const getToken = () => store.getState().auth.token;

    const buildConfig = (t) => {
        const isFormData = options.body instanceof FormData;
        const baseHeaders = isFormData
            ? { 'Authorization': `Bearer ${t}` }
            : { 'Content-Type': 'application/json', 'Authorization': `Bearer ${t}` };
        return { ...options, headers: { ...baseHeaders, ...options.headers } };
    };

    const response = await fetch(url, buildConfig(getToken()));

    if (response.status === 401) {
        const refreshed = await store.dispatch(refreshAccessToken());
        if (refreshed) {
            return fetch(url, buildConfig(getToken()));
        }
    }

    return response;
};

export default authFetch;
